/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {FabMessageService} from '@fabric/components/message';
import {DISMISS_MSG, VEHICLE_PROPULSION_COLDEF_NO_FILTER} from '../../../common/constants';
import {
  GlobalScenarioSelectComponent
} from '../../../core/components/global-scenario-select/global-scenario-select.component';
import {DeletePopUpComponent} from '../../../core/components/pop-ups/delete-pop-up/delete-pop-up.component';
import {StateService} from '../../../core/state/state.service';
import {GlobalScenario} from '../../../models/global-scenario-dto.model';
import {GlobalScenarioService} from '../../../services/global-scenario-service';

@Component({
    selector: 'app-manage-global-scenario',
    templateUrl: './manage-global-scenario.component.html',
    styleUrls: ['./manage-global-scenario.component.scss'],
    standalone: false
})
export class ManageGlobalScenarioComponent implements OnInit {
  protected readonly VEHICLE_PROPULSION_COLDEF_NO_FILTER = VEHICLE_PROPULSION_COLDEF_NO_FILTER;
  @ViewChild('globalScenarioSelect') globalScenarioSelect: GlobalScenarioSelectComponent;

  globalScenarioForm: FormGroup;
  showSpinner: boolean;
  selectedGlobalScenario: GlobalScenario;

  constructor(public snackBar: FabMessageService,
              private readonly globalScenarioService: GlobalScenarioService,
              readonly stateService: StateService,
              private readonly dialog: MatDialog,
              readonly router: Router) {
  }

  ngOnInit(): void {
    this.selectedGlobalScenario = null;
    this.globalScenarioForm = new FormGroup({
      updatedGlobalScenario: new FormControl({id: '', globalScenarioName: ''}, [Validators.required])
    });
  }

  /**
   * Calls the proper function to fetch the member scenarios based on the selected scenario
   * @param event The event generated by the child
   */
  onSelectGlobal(event: any) {
    this.selectedGlobalScenario = event.globalScenario;
  }

  /**
   * Navigates to edit global scenario page
   */
  openEditGlobalScenario(): void {
    this.router.navigate(['/edit-global-scenario'],
      {
        queryParams: {
          globalScenarioName: this.selectedGlobalScenario.globalScenarioName,
          globalScenarioId: this.selectedGlobalScenario.id,
          isEdit: true
        }
      });
  }

  /**
   * Navigates to add global scenario page
   */
  openCreateGlobalScenario(): void {
    this.router.navigate(['/edit-global-scenario'],
      {
        queryParams: {
          isEdit: false
        }
      });
  }

  /**
   * Send delete request to delete the global scenario from both the global scenario table
   * and the global vehicle scenario mapping table
   */
  onDelete(): void {
    const dialogRef = this.dialog.open(DeletePopUpComponent, {
      data: {
        title: 'Delete',
        valueToDelete: this.selectedGlobalScenario.globalScenarioName
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res && res.data.deleteValue) {

        this.globalScenarioService.deleteGlobalScenarioById(this.selectedGlobalScenario.id).subscribe({
          error: err => {
            this.errorHandle(err);
          },
          complete: () => {
            this.snackBar.displaySuccess('Global Scenario DELETED!', DISMISS_MSG);
            this.globalScenarioSelect.ngOnInit();
          }
        });
      }
    });
  }

  /**
   * display message on error.
   * @param error custom error message.
   */
  errorHandle(error: string): void {
    this.showSpinner = false;
    this.snackBar.displayError(error, DISMISS_MSG);
  }
}
